/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupHeader from "vux/src/components/popup-header/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
export default {
  components: {
    Cell: Cell,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupHeader: PopupHeader,
    Checklist: Checklist
  },
  props: {
    title: {
      type: String
    },
    value: {
      type: Array
    },
    data: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: i18n.tc("237")
    }
  },
  directives: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      isShow: false,
      selectValue: this.value,
      checklist: []
    };
  },
  computed: {
    list: function list() {
      return this.data.map(function (item) {
        return {
          key: item.value,
          value: item.name
        };
      });
    }
  },
  filters: {
    dataFilter: function dataFilter(val, data) {
      var arr = data.filter(function (item) {
        return val.indexOf(item.key) !== -1;
      }).map(function (item) {
        return item.value;
      });
      return arr.join(',');
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    selectValue: function selectValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    submit: function submit() {
      this.selectValue = this.checklist;
      this.$emit('on-change', this.selectValue, this.data);
      this.isShow = false;
    },
    cancel: function cancel() {
      this.checklist = this.selectValue;
      this.isShow = false;
    }
  },
  created: function created() {
    this.checklist = this.selectValue.slice(0);
  }
};